/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDescriptionAdditionalOptionsContent_item$ref = any;
export type PdpSharedDescriptionAdditionalOptions_item$ref = any;
export type PdpSharedDescriptionAdditionalOptions_item = {
    readonly isCustomizable: boolean | null;
    readonly attributes: {
        readonly customizable: ReadonlyArray<{
            readonly text: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedDescriptionAdditionalOptionsContent_item$ref;
    readonly " $refType": PdpSharedDescriptionAdditionalOptions_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAdditionalOptions_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustomizable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "attributes",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "customizable",
          "storageKey": null,
          "args": null,
          "concreteType": "AttributeValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_item",
      "args": null
    }
  ]
};
(node as any).hash = 'fb90908aff4107fefd703844e47c34da';
export default node;
